import { render, staticRenderFns } from "./otpValidate.vue?vue&type=template&id=36d04c9d&scoped=true"
import script from "./otpValidate.vue?vue&type=script&lang=js"
export * from "./otpValidate.vue?vue&type=script&lang=js"
import style0 from "./otpValidate.vue?vue&type=style&index=0&id=36d04c9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d04c9d",
  null
  
)

export default component.exports